// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './globals.css' // Use globals.css instead of index.css
import AppRouter from './router' // Use AppRouter

// Initialize Wujie setup - 使用环境变量配置子应用 URL
// 暂时移除主应用启动时的 setupApp，改为由 AdsApp 组件按需加载
// 这有助于解决在生产环境下从登录页跳转后子应用不渲染的问题

// 暂时移除 StrictMode 以避免开发环境下的重复 API 调用/Three.js 初始化问题
createRoot(document.getElementById('root')!).render(
    <AppRouter />
)
